module.exports = __webpack_public_path__ + "img/ins_step2.5b78dfe2.svg";